import { getDialogHooks } from 'utilities/dialog-context/dialog-context-helpers';
import {
  PhoneNumberDialog,
  PhoneNumberDialogCallbackInput,
  PhoneNumberUniqueProps,
} from '../PhoneNumberDialog';

const { useDialogForContext, useDialog: usePhoneNumberDialog } = getDialogHooks<
  PhoneNumberUniqueProps,
  PhoneNumberDialogCallbackInput
>(PhoneNumberDialog);
export const usePhoneNumberDialogForContext = useDialogForContext;
export default usePhoneNumberDialog;
